export default {"src":"/_next/static/media/caret-up.dec506db.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};